"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAdaptiveCardsHostConfig;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _react = require("react");

var _adaptiveCardHostConfig = _interopRequireDefault(require("../Styles/adaptiveCardHostConfig"));

var _useAdaptiveCardsContext = _interopRequireDefault(require("./internal/useAdaptiveCardsContext"));

var useStyleOptions = _botframeworkWebchatComponent.hooks.useStyleOptions;

function useAdaptiveCardsHostConfig() {
  var _useAdaptiveCardsCont = (0, _useAdaptiveCardsContext.default)(),
      hostConfigFromProps = _useAdaptiveCardsCont.hostConfigFromProps;

  var _useStyleOptions = useStyleOptions(),
      _useStyleOptions2 = (0, _slicedToArray2.default)(_useStyleOptions, 1),
      styleOptions = _useStyleOptions2[0];

  var patchedHostConfig = (0, _react.useMemo)(function () {
    return hostConfigFromProps || (0, _adaptiveCardHostConfig.default)(styleOptions);
  }, [hostConfigFromProps, styleOptions]);
  return [patchedHostConfig];
}